import React, { useState, useEffect } from 'react';
import { Button, Input, Nav } from 'rsuite';
import TrashIcon from '@rsuite/icons/Trash';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import PagePreviousIcon from '@rsuite/icons/PagePrevious';
import PageNextIcon from '@rsuite/icons/PageNext';
import SearchIcon from '@rsuite/icons/Search';
import {
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  IconButton,
  FlexboxGrid,
  Col,
  InputGroup,
  Form,
  useToaster,
  Message,
  Table,
  SelectPicker,
  ButtonToolbar,
  ButtonGroup,
  Pagination
} from 'rsuite';

interface RowDatacategorydata {
  id: string; // or number, depending on your data
  attributes: {
    CategoryCode: string;
    CategoryName: string;
  };
}
interface RowDataProducttype {
  id: string; // or number, depending on your data
  attributes: {
    ProductTypeCode: string;
    ProductTypeName: string;
  };
}
interface RowDataCollection {
  id: string; // or number, depending on your data
  attributes: {
    MatCollectionCode: string;
    MatCollectionName: string;
  };
}
interface RowDataFinish {
  id: string; // or number, depending on your data
  attributes: {
    FinishCode: string;
    FinishName: string;
  };
}
interface RowDataColor {
  id: string; // or number, depending on your data
  attributes: {
    ColorCode: string;
    ColorName: string;
  };
}
interface RowDataHSN {
  id: string; // or number, depending on your data
  attributes: {
    hscode: string;

  };
}
interface RowDataMAT {
  id: string; // or number, depending on your data
  attributes: {
    MaterialCode: string;
    MaterialName: string;

  };
}



const { Column, HeaderCell, Cell } = Table;

let categoryCodeCounter1 = 1;
let categoryCodeCounter2 = 1;
let categoryCodeCounter3 = 1;
let categoryCodeCounter4 = 1;
let categoryCodeCounter5 = 1;
let categoryCodeCounter7 = 1;

const Master = () => {

  const ip = 'http://192.168.1.23:1337';
  const [activeKey, setActiveKey] = useState('content1');

  const handleNavSelect = (eventKey) => {
    setActiveKey(eventKey);
  };
  const toaster = useToaster();
  const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
  const [editedData, setEditedData] = useState<Record<string, Partial<RowDatacategorydata['attributes']>>>({});


  ////////////////  Function For 1 Start /////////////////

  const [category, setCategory] = useState({
    CategoryCode: "",
    CategoryName: "",
  });
  // Fetch Data from API Start
  const [categorydata, setCategorydata] = useState<RowDatacategorydata[]>([]);
  const [paginationcategory, setPaginationCategory] = useState({
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  });
  useEffect(() => {
    fetchData();
  }, [categorydata]);
  const fetchData = async () => {
    const response = await fetch(`${ip}/api/mstcategories?pagination[page]=${activePagecategorie}`);
    const json = await response.json();
    setCategorydata(json.data);
    setPaginationCategory(json.meta.pagination);
  };
  const [activePagecategorie, setActivePagecategorie] = useState(1);
  const generateNextCategoryCode = () => {
    const categoryCount = categorydata.length;
    const nextCode = categoryCount + 1;
    return `CAT-${nextCode.toString().padStart(3, "0")}`;
  };
  const handleEditRowCategory = (rowData) => {
    setEditedRowIds((prevRowIds) => [...prevRowIds, rowData.id]);
    setEditedData((prevData) => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes },
    }));
  };
  const url = `${ip}/api/mstcategories`
  const submit = e => {
    if (category.CategoryName === '') {
      toaster.push(<Message showIcon type='error'>
        Please Enter Company Name.
      </Message>, { placement: 'topCenter' })
    } else {
      e.preventDefault();
      const nextCategoryCode = generateNextCategoryCode();
      const formData = new FormData();
      formData.append('data', JSON.stringify({ ...category, CategoryCode: nextCategoryCode }));
      fetch(url, {
        method: 'POST',
        body: formData,
      })
        .then(response => fetchData())
        .then(data => console.log(category))
        .catch(error => console.error(error))
      categoryCodeCounter1++;
      setCategory({
        CategoryCode: "",
        CategoryName: "",
      });
      toaster.push(<Message showIcon type='success'>
        Data Save Successefully.
      </Message>, { placement: 'topCenter' })
    }
  };
  //  Fetch Data from API End
  const handleInputChange = (inputName, value, index) => {
    setCategory({ ...category, [inputName]: value });
  };
  // Delete Data from API Start
  // const handleDeleteRow = async (rowId) => {
  //     try {
  //         const response = await fetch(`${ip}/api/mstcategories/${rowId}`, {
  //             method: 'DELETE',
  //         });
  //         if (response.ok) {
  //             // Row deletion was successful, update your local data or refresh the table
  //             const updatedData1 = categorydata.filter((row) => row.id !== rowId);
  //             setCategorydata(updatedData1);
  //             console.log('Row deleted successfully.');
  //         } else {
  //             console.log('Failed to delete row.');
  //         }
  //     } catch (error) {
  //         console.error('Error deleting row:', error);
  //     }
  // };
  // Delete Data from API End
  const handleSaveRowCategory = async (rowId: string) => {
    try {
      const rowData = categorydata.find((row) => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData: RowDatacategorydata = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedData[rowId] },
      };

      const response = await fetch(`${ip}/api/mstcategories/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: updatedRowData.attributes }),
      });
      if (response.ok) {
        // If the API call is successful, update the data
        fetchData();
        setEditedRowIds((prevRowIds) => prevRowIds.filter((id) => id !== rowId));
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeCategory = (rowId, fieldName, value) => {
    setEditedData((prevData) => ({
      ...prevData,
      [rowId]: {
        ...prevData[rowId],
        [fieldName]: value,
      },
    }));
  };
  ////////////////  Function For 1 End /////////////////

  ////////////////  Function For 2 Start /////////////////

  const [productType, setProductType] = useState({
    ProductTypeCode: "",
    ProductTypeName: "",
  });
  // Fetch Data from API Start
  const [productTypedata, setProductTypedata] = useState<RowDataProducttype[]>([]);
  const [editedRowIdsProduct, setEditedRowIdsProduct] = useState<string[]>([]);
  const [editedDataProduct, setEditedDataProduct] = useState<Record<string, Partial<RowDataProducttype['attributes']>>>({});

  const [activePageproducttype, setActivePageproducttype] = React.useState(1);
  const [paginationproductType, setPaginationProductType] = useState({
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  });
  useEffect(() => {
    fetchData2();
  }, [productTypedata]);
  const fetchData2 = async () => {
    const response = await fetch(`${ip}/api/mstproducttypes?pagination[page]=${activePageproducttype}`);
    const json = await response.json();
    setProductTypedata(json.data);
    setPaginationProductType(json.meta.pagination);
  };
  const handleEditRowProduct = (rowData) => {
    setEditedRowIdsProduct((prevRowIds) => [...prevRowIds, rowData.id]);
    setEditedDataProduct((prevData) => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes },
    }));
  };
  const generateNextCategoryCode2 = () => {
    const categoryCount = productTypedata.length;
    const nextCode = categoryCount + 1;
    return `PTY-${nextCode.toString().padStart(3, "0")}`;
  };
  const url2 = `${ip}/api/mstproducttypes`;
  const submit2 = e => {
    if (productType.ProductTypeName === '') {
      toaster.push(<Message showIcon type='error'>
        Please Enter Product Type.
      </Message>, { placement: 'topCenter' })
    } else {
      e.preventDefault();
      const nextCategoryCode = generateNextCategoryCode2();
      const formData = new FormData();
      formData.append('data', JSON.stringify({ ...productType, ProductTypeCode: nextCategoryCode }));
      fetch(url2, {
        method: 'POST',
        body: formData,
      })
        .then(response => fetchData2())
        .then(data => console.log(productType))
        .catch(error => console.error(error))
      categoryCodeCounter2++;
      setProductType({
        ProductTypeCode: "",
        ProductTypeName: "",
      });
      toaster.push(<Message showIcon type='success'>
        Data Save Successefully.
      </Message>, { placement: 'topCenter' })
    }
  };
  //  Fetch Data from API End
  const handleInputChange2 = (inputName, value, index) => {
    setProductType({ ...productType, [inputName]: value });
  };
  // Delete Data from API Start
  // const handleDeleteRow2 = async (rowId) => {
  //     try {
  //         const response = await fetch(`${ip}/api/mstproducttypes/${rowId}`, {
  //             method: 'DELETE',
  //         });
  //         if (response.ok) {
  //             // Row deletion was successful, update your local data or refresh the table
  //             const updatedData1 = productTypedata.filter((row) => row.id !== rowId);
  //             setProductTypedata(updatedData1);
  //             console.log('Row deleted successfully.');
  //         } else {
  //             console.log('Failed to delete row.');
  //         }
  //     } catch (error) {
  //         console.error('Error deleting row:', error);
  //     }
  // };
  // Delete Data from API End
  const handleSaveRowProduct = async (rowId: string) => {
    try {
      const rowData = productTypedata.find((row) => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData: RowDataProducttype = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedDataProduct[rowId] },
      };

      const response = await fetch(`${ip}/api/mstproducttypes/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: updatedRowData.attributes }),
      });
      if (response.ok) {
        // If the API call is successful, update the data
        fetchData2();
        setEditedRowIdsProduct((prevRowIds) => prevRowIds.filter((id) => id !== rowId));
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeProduct = (rowId, fieldName, value) => {
    setEditedDataProduct((prevData) => ({
      ...prevData,
      [rowId]: {
        ...prevData[rowId],
        [fieldName]: value,
      },
    }));
  };
  ////////////////  Function For 2 End /////////////////

  ////////////////  Function For 3 Start /////////////////

  const [collection, setCollection] = useState({
    MatCollectionCode: "",
    MatCollectionName: "",
  });
  // Fetch Data from API Start
  const [collectiondata, setCollectiondata] = useState<RowDataCollection[]>([]);
  const [editedRowIdsCollection, setEditedRowIdsCollection] = useState<string[]>([]);
  const [editedDataCollection, setEditedDataCollection] = useState<Record<string, Partial<RowDataCollection['attributes']>>>({});
  const [paginationcollection, setPaginationCollection] = useState({
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  });
  const [activePagematerialcollections, setActivePagematerialcollections] = React.useState(1);
  useEffect(() => {
    fetchData3();
  }, [collectiondata]);
  const fetchData3 = async () => {
    const response = await fetch(`${ip}/api/mstmaterialcollections?pagination[page]=${activePagematerialcollections}`);
    const json = await response.json();
    setCollectiondata(json.data);
    setPaginationCollection(json.meta.pagination);
  };
  const generateNextCategoryCode3 = () => {
    const categoryCount = collectiondata.length;
    const nextCode = categoryCount + 1;
    return `COL-${nextCode.toString().padStart(3, "0")}`;
  };
  const handleEditRowCollection = (rowData) => {
    setEditedRowIdsCollection((prevRowIds) => [...prevRowIds, rowData.id]);
    setEditedDataCollection((prevData) => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes },
    }));
  };
  const url3 = `${ip}/api/mstmaterialcollections`
  const submit3 = e => {
    if (collection.MatCollectionName === '') {
      toaster.push(<Message showIcon type='error'>
        Please Enter Collection Name.
      </Message>, { placement: 'topCenter' })
    } else {
      e.preventDefault();
      const nextCategoryCode = generateNextCategoryCode3();
      const formData = new FormData();
      formData.append('data', JSON.stringify({ ...collection, MatCollectionCode: nextCategoryCode }));
      fetch(url3, {
        method: 'POST',
        body: formData,
      })
        .then(response => fetchData3())
        .then(data => console.log(collection))
        .catch(error => console.error(error))
      categoryCodeCounter3++;
      setCollection({
        MatCollectionCode: "",
        MatCollectionName: "",
      });
      toaster.push(<Message showIcon type='success'>
        Data Save Successefully.
      </Message>, { placement: 'topCenter' })
    }
  };
  //  Fetch Data from API End
  const handleInputChange3 = (inputName, value, index) => {
    setCollection({ ...collection, [inputName]: value });
  };
  // Delete Data from API Start
  // const handleDeleteRow3 = async (rowId) => {
  //     try {
  //         const response = await fetch(`${ip}/api/mstmaterialcollections/${rowId}`, {
  //             method: 'DELETE',
  //         });
  //         if (response.ok) {
  //             // Row deletion was successful, update your local data or refresh the table
  //             const updatedData1 = collectiondata.filter((row) => row.id !== rowId);
  //             setCollectiondata(updatedData1);
  //             console.log('Row deleted successfully.');
  //         } else {
  //             console.log('Failed to delete row.');
  //         }
  //     } catch (error) {
  //         console.error('Error deleting row:', error);
  //     }
  // };
  // Delete Data from API End
  const handleSaveRowCollection = async (rowId: string) => {
    try {
      const rowData = collectiondata.find((row) => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData: RowDataCollection = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedDataCollection[rowId] },
      };

      const response = await fetch(`${ip}/api/mstmaterialcollections/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: updatedRowData.attributes }),
      });
      if (response.ok) {
        // If the API call is successful, update the data
        fetchData3();
        setEditedRowIdsCollection((prevRowIds) => prevRowIds.filter((id) => id !== rowId));
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeCollection = (rowId, fieldName, value) => {
    setEditedDataCollection((prevData) => ({
      ...prevData,
      [rowId]: {
        ...prevData[rowId],
        [fieldName]: value,
      },
    }));
  };
  ////////////////  Function For 3 End /////////////////

  ////////////////  Function For 4 Start /////////////////

  const [finish, setFinish] = useState({
    FinishCode: "",
    FinishName: "",
  });
  // Fetch Data from API Start
  const [finishdata, setFinishdata] = useState<RowDataFinish[]>([]);
  const [editedRowIdsFinish, setEditedRowIdsFinish] = useState<string[]>([]);
  const [editedDataFinish, setEditedDataFinish] = useState<Record<string, Partial<RowDataFinish['attributes']>>>({});
  const [paginationfinish, setPaginationFinish] = useState({
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  });
  const [activePagefinishes, setActivePagefinishes] = React.useState(1);
  useEffect(() => {
    fetchData4();
  }, [finishdata]);
  const fetchData4 = async () => {
    const response = await fetch(`${ip}/api/mstfinishes?pagination[page]=${activePagefinishes}`);
    const json = await response.json();
    setFinishdata(json.data);
    setPaginationFinish(json.meta.pagination);
  };
  const generateNextCategoryCode4 = () => {
    const categoryCount = finishdata.length;
    const nextCode = categoryCount + 1;
    return `FIN-${nextCode.toString().padStart(3, "0")}`;
  };
  const handleEditRowFinish = (rowData) => {
    setEditedRowIdsFinish((prevRowIds) => [...prevRowIds, rowData.id]);
    setEditedDataFinish((prevData) => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes },
    }));
  };
  const url4 = `${ip}/api/mstfinishes`
  const submit4 = e => {
    if (finish.FinishName === '') {
      toaster.push(<Message showIcon type='error'>
        Please Enter Finish Name.
      </Message>, { placement: 'topCenter' })
    } else {
      e.preventDefault();
      const nextCategoryCode = generateNextCategoryCode4();
      const formData = new FormData();
      formData.append('data', JSON.stringify({ ...finish, FinishCode: nextCategoryCode }));
      fetch(url4, {
        method: 'POST',
        body: formData,
      })
        .then(response => fetchData4())
        .then(data => console.log(finish))
        .catch(error => console.error(error))
      categoryCodeCounter4++;
      setFinish({
        FinishCode: "",
        FinishName: "",
      });
      toaster.push(<Message showIcon type='success'>
        Data Save Successefully.
      </Message>, { placement: 'topCenter' })
    }
  };
  //  Fetch Data from API End
  const handleInputChange4 = (inputName, value, index) => {
    setFinish({ ...finish, [inputName]: value });
  };
  // Delete Data from API Start
  // const handleDeleteRow4 = async (rowId) => {
  //     try {
  //         const response = await fetch(`${ip}/api/mstfinishes/${rowId}`, {
  //             method: 'DELETE',
  //         });
  //         if (response.ok) {
  //             // Row deletion was successful, update your local data or refresh the table
  //             const updatedData1 = finishdata.filter((row) => row.id !== rowId);
  //             setFinishdata(updatedData1);
  //             console.log('Row deleted successfully.');
  //         } else {
  //             console.log('Failed to delete row.');
  //         }
  //     } catch (error) {
  //         console.error('Error deleting row:', error);
  //     }
  // };
  // Delete Data from API End
  const handleSaveRowFinish = async (rowId: string) => {
    try {
      const rowData = finishdata.find((row) => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData: RowDataFinish = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedDataFinish[rowId] },
      };

      const response = await fetch(`${ip}/api/mstfinishes/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: updatedRowData.attributes }),
      });
      if (response.ok) {
        // If the API call is successful, update the data
        fetchData4();
        setEditedRowIdsFinish((prevRowIds) => prevRowIds.filter((id) => id !== rowId));
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeFinish = (rowId, fieldName, value) => {
    setEditedDataFinish((prevData) => ({
      ...prevData,
      [rowId]: {
        ...prevData[rowId],
        [fieldName]: value,
      },
    }));
  };
  ////////////////  Function For 4 End /////////////////

  ////////////////  Function For 5 Start /////////////////

  const [color, setColor] = useState({
    ColorCode: "",
    ColorName: "",
  });
  // Fetch Data from API Start
  const [colordata, setColordata] = useState<RowDataColor[]>([]);
  const [editedRowIdsColor, setEditedRowIdsColor] = useState<string[]>([]);
  const [editedDataColor, setEditedDataColor] = useState<Record<string, Partial<RowDataColor['attributes']>>>({});
  const [paginationcolor, setPaginationColor] = useState({
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  });

  useEffect(() => {
    fetchData5();
  }, [colordata]);
  const fetchData5 = async () => {
    const response = await fetch(`${ip}/api/mstcolors?pagination[page]=${activePagecolor}`);
    const json = await response.json();
    setColordata(json.data);
    setPaginationColor(json.meta.pagination);
  };
  const [activePagecolor, setActivePagecolor] = React.useState(1);
  const generateNextCategoryCode5 = () => {
    const categoryCount = colordata.length;
    const nextCode = categoryCount + 1;
    return `CLR-${nextCode.toString().padStart(3, "0")}`;
  };
  const handleEditRowColor = (rowData) => {
    setEditedRowIdsColor((prevRowIds) => [...prevRowIds, rowData.id]);
    setEditedDataColor((prevData) => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes },
    }));
  };
  const url5 = `${ip}/api/mstcolors`
  const submit5 = e => {
    if (color.ColorName === '') {
      toaster.push(<Message showIcon type='error'>
        Please Enter Color Name.
      </Message>, { placement: 'topCenter' })
    } else {
      e.preventDefault();
      const nextCategoryCode = generateNextCategoryCode5();
      const formData = new FormData();
      formData.append('data', JSON.stringify({ ...color, ColorCode: nextCategoryCode }));
      fetch(url5, {
        method: 'POST',
        body: formData,
      })
        .then(response => fetchData5())
        .then(data => console.log(color))
        .catch(error => console.error(error))
      categoryCodeCounter5++;
      setColor({
        ColorCode: "",
        ColorName: "",
      });
      toaster.push(<Message showIcon type='success'>
        Data Save Successefully.
      </Message>, { placement: 'topCenter' })
    }
  };
  //  Fetch Data from API End
  const handleInputChange5 = (inputName, value, index) => {
    setColor({ ...color, [inputName]: value });
  };
  // Delete Data from API Start
  // const handleDeleteRow5 = async (rowId) => {
  //     try {
  //         const response = await fetch(`${ip}/api/mstcolors/${rowId}`, {
  //             method: 'DELETE',
  //         });
  //         if (response.ok) {
  //             // Row deletion was successful, update your local data or refresh the table
  //             const updatedData1 = colordata.filter((row) => row.id !== rowId);
  //             setColordata(updatedData1);
  //             console.log('Row deleted successfully.');
  //         } else {
  //             console.log('Failed to delete row.');
  //         }
  //     } catch (error) {
  //         console.error('Error deleting row:', error);
  //     }
  // };
  // Delete Data from API End
  const handleSaveRowColor = async (rowId: string) => {
    try {
      const rowData = colordata.find((row) => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData: RowDataColor = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedDataColor[rowId] },
      };

      const response = await fetch(`${ip}/api/mstcolors/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: updatedRowData.attributes }),
      });
      if (response.ok) {
        // If the API call is successful, update the data
        fetchData5();
        setEditedRowIdsColor((prevRowIds) => prevRowIds.filter((id) => id !== rowId));
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeColor = (rowId, fieldName, value) => {
    setEditedDataColor((prevData) => ({
      ...prevData,
      [rowId]: {
        ...prevData[rowId],
        [fieldName]: value,
      },
    }));
  };
  ////////////////  Function For 5 End /////////////////

  ////////////////  Function For 6 Start /////////////////

  const [hscode, setHscode] = useState({
    hscode: "",
  });
  // Fetch Data from API Start
  const [hsdata, setHsdata] = useState<RowDataHSN[]>([]);
  const [editedRowIdsHSN, setEditedRowIdsHSN] = useState<string[]>([]);
  const [editedDataHSN, setEditedDataHSN] = useState<Record<string, Partial<RowDataHSN['attributes']>>>({});
  const [paginationhs, setPaginationHs] = useState({
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  });
  const [activePagehscode, setActivePagehscode] = React.useState(1);
  useEffect(() => {
    fetchData6();
  }, [hsdata]);
  const fetchData6 = async () => {
    const response = await fetch(`${ip}/api/msthscodes?pagination[page]=${activePagehscode}`);
    const json = await response.json();
    setHsdata(json.data);
    setPaginationHs(json.meta.pagination);
  };
  const handleEditRowHSN = (rowData) => {
    setEditedRowIdsHSN((prevRowIds) => [...prevRowIds, rowData.id]);
    setEditedDataHSN((prevData) => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes },
    }));
  };
  const url6 = `${ip}/api/msthscodes`
  const submit6 = e => {
    if (hscode.hscode === '') {
      toaster.push(<Message showIcon type='error'>
        Please Enter HSN COde.
      </Message>, { placement: 'topCenter' })
    } else {
      e.preventDefault();
      const formData = new FormData();
      formData.append('data', JSON.stringify(hscode));
      fetch(url6, {
        method: 'POST',
        body: formData,
      })
        .then(response => fetchData6())
        .then(data => console.log(hscode))
        .catch(error => console.error(error))
      setHscode({
        hscode: "",
      });
      toaster.push(<Message showIcon type='success'>
        Data Save Successefully.
      </Message>, { placement: 'topCenter' })
    }
  };
  //  Fetch Data from API End
  const handleInputChange6 = (inputName, value, index) => {
    setHscode({ ...hscode, [inputName]: value });
  };
  // Delete Data from API Start
  // const handleDeleteRow6 = async (rowId) => {
  //     try {
  //         const response = await fetch(`${ip}/api/msthscodes/${rowId}`, {
  //             method: 'DELETE',
  //         });
  //         if (response.ok) {
  //             // Row deletion was successful, update your local data or refresh the table
  //             const updatedData1 = hsdata.filter((row) => row.id !== rowId);
  //             setHsdata(updatedData1);
  //             console.log('Row deleted successfully.');
  //         } else {
  //             console.log('Failed to delete row.');
  //         }
  //     } catch (error) {
  //         console.error('Error deleting row:', error);
  //     }
  // };
  // Delete Data from API End
  const handleSaveRowHSN = async (rowId: string) => {
    try {
      const rowData = hsdata.find((row) => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData: RowDataHSN = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedDataHSN[rowId] },
      };

      const response = await fetch(`${ip}/api/msthscodes/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: updatedRowData.attributes }),
      });
      if (response.ok) {
        // If the API call is successful, update the data
        fetchData6();
        setEditedRowIdsHSN((prevRowIds) => prevRowIds.filter((id) => id !== rowId));
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeHSN = (rowId, fieldName, value) => {
    setEditedDataHSN((prevData) => ({
      ...prevData,
      [rowId]: {
        ...prevData[rowId],
        [fieldName]: value,
      },
    }));
  };
  ////////////////  Function For 6 End /////////////////

  ////////////////  Function For 7 Start /////////////////

  const [material, setMaterial] = useState({
    MaterialCode: "",
    MaterialName: "",
  });
  // Fetch Data from API Start
  const [materialdata, setMaterialdata] = useState<RowDataMAT[]>([]);
  const [editedRowIdsMAT, setEditedRowIdsMAT] = useState<string[]>([]);
  const [editedDataMAT, setEditedDataMAT] = useState<Record<string, Partial<RowDataMAT['attributes']>>>({});
  const [paginationmaterial, setPaginationMaterial] = useState({
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  });
  const [activePagematerial, setActivePagematerial] = React.useState(1);
  useEffect(() => {
    fetchData7();
  }, [materialdata]);
  const fetchData7 = async () => {
    const response = await fetch(`${ip}/api/mstmaterials?pagination[page]=${activePagematerial}`);
    const json = await response.json();
    setMaterialdata(json.data);
    setPaginationMaterial(json.meta.pagination);
  };
  const generateNextCategoryCode7 = () => {
    const categoryCount = materialdata.length;
    const nextCode = categoryCount + 1;
    return `MAT-${nextCode.toString().padStart(3, "0")}`;
  };
  const handleEditRowMAT = (rowData) => {
    setEditedRowIdsMAT((prevRowIds) => [...prevRowIds, rowData.id]);
    setEditedDataMAT((prevData) => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes },
    }));
  };
  const url7 = `${ip}/api/mstmaterials`
  const submit7 = e => {
    if (material.MaterialName === '') {
      toaster.push(<Message showIcon type='error'>
        Please Enter Company Name.
      </Message>, { placement: 'topCenter' })
    } else {
      e.preventDefault();
      const nextCategoryCode = generateNextCategoryCode7();
      const formData = new FormData();
      formData.append('data', JSON.stringify({ ...material, MaterialCode: nextCategoryCode }));
      fetch(url7, {
        method: 'POST',
        body: formData,
      })
        .then(response => fetchData7())
        .then(data => console.log(material))
        .catch(error => console.error(error))
      categoryCodeCounter7++;
      setMaterial({
        MaterialCode: "",
        MaterialName: "",
      });
      toaster.push(<Message showIcon type='success'>
        Data Save Successefully.
      </Message>, { placement: 'topCenter' })
    }
  };
  //  Fetch Data from API End
  const handleInputChange7 = (inputName, value, index) => {
    setMaterial({ ...material, [inputName]: value });
  };
  // Delete Data from API Start
  // const handleDeleteRow7 = async (rowId) => {
  //     try {
  //         const response = await fetch(`${ip}/api/mstmaterials/${rowId}`, {
  //             method: 'DELETE',
  //         });
  //         if (response.ok) {
  //             // Row deletion was successful, update your local data or refresh the table
  //             const updatedData1 = materialdata.filter((row) => row.id !== rowId);
  //             setMaterialdata(updatedData1);
  //             console.log('Row deleted successfully.');
  //         } else {
  //             console.log('Failed to delete row.');
  //         }
  //     } catch (error) {
  //         console.error('Error deleting row:', error);
  //     }
  // };
  // Delete Data from API End
  const handleSaveRowMAT = async (rowId: string) => {
    try {
      const rowData = materialdata.find((row) => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData: RowDataMAT = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedDataMAT[rowId] },
      };

      const response = await fetch(`${ip}/api/mstmaterials/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: updatedRowData.attributes }),
      });
      if (response.ok) {
        // If the API call is successful, update the data
        fetchData7();
        setEditedRowIdsMAT((prevRowIds) => prevRowIds.filter((id) => id !== rowId));
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeMAT = (rowId, fieldName, value) => {
    setEditedDataMAT((prevData) => ({
      ...prevData,
      [rowId]: {
        ...prevData[rowId],
        [fieldName]: value,
      },
    }));
  };
  ////////////////  Function For 7 End /////////////////

  ////////////////  Searching For 1 Start /////////////////
  const [searchQuery1, setSearchQuery1] = useState('');
  const handleSearch1 = (value) => {
    setSearchQuery1(value);
  };
  ////////////////  Searching For 1 End /////////////////
  ////////////////  Searching For 2 Start /////////////////
  const [searchQuery2, setSearchQuery2] = useState('');
  const handleSearch2 = (value) => {
    setSearchQuery2(value);
  };
  ////////////////  Searching For 2 End /////////////////
  ////////////////  Searching For 3 Start /////////////////
  const [searchQuery3, setSearchQuery3] = useState('');
  const handleSearch3 = (value) => {
    setSearchQuery3(value);
  };
  ////////////////  Searching For 3 End /////////////////
  ////////////////  Searching For 4 Start /////////////////
  const [searchQuery4, setSearchQuery4] = useState('');
  const handleSearch4 = (value) => {
    setSearchQuery4(value);
  };
  ////////////////  Searching For 4 End /////////////////
  ////////////////  Searching For 5 Start /////////////////
  const [searchQuery5, setSearchQuery5] = useState('');
  const handleSearch5 = (value) => {
    setSearchQuery5(value);
  };
  ////////////////  Searching For 5 End /////////////////
  ////////////////  Searching For 6 Start /////////////////
  const [searchQuery6, setSearchQuery6] = useState('');
  const handleSearch6 = (value) => {
    setSearchQuery6(value);
  };
  ////////////////  Searching For 6 End /////////////////
  ////////////////  Searching For 7 Start /////////////////
  const [searchQuery7, setSearchQuery7] = useState('');
  const handleSearch7 = (value) => {
    setSearchQuery7(value);
  };
  ////////////////  Searching For 7 End /////////////////



  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start'>
              <h3 className="title">Masters</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Master</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack>
              <Nav appearance="tabs" activeKey={activeKey} onSelect={handleNavSelect} style={{ display: 'flex', gap: '20px' }}>
                <Nav.Item eventKey="content1"><b>Category</b></Nav.Item>
                <Nav.Item eventKey="content2"><b>Product Type</b></Nav.Item>
                <Nav.Item eventKey="content3"><b>Collection</b></Nav.Item>
                <Nav.Item eventKey="content4"><b>Finish</b></Nav.Item>
                <Nav.Item eventKey="content5"><b>Color</b></Nav.Item>
                <Nav.Item eventKey="content6"><b>HSN</b></Nav.Item>
                <Nav.Item eventKey="content7"><b>Material</b></Nav.Item>
              </Nav>
            </Stack>

          </Stack>

        </Stack>
        <Divider className='divide' />
        <Panel className='row'>
          {activeKey === 'content1' && (
            <>
              <Form.ControlLabel><b>Category Name</b></Form.ControlLabel>
              <Stack justifyContent='space-between' style={{ marginBottom: '10px' }}>
                <Stack spacing={160}>
                  <Input id="CategoryName"
                    name="CategoryName"
                    style={{ width: '180%' }}
                    value={category && category.CategoryName ? category.CategoryName : ''} onChange={value => handleInputChange('CategoryName', value, 0)}
                    onPressEnter={submit}
                  />
                  <Button appearance='primary' color='cyan' onClick={submit}> Add</Button>
                </Stack>
                <Stack>
                  <InputGroup inside >
                    <Input placeholder="Search" type="text" value={searchQuery1} onChange={handleSearch1} />
                    <InputGroup.Addon>
                      <SearchIcon />
                    </InputGroup.Addon>
                  </InputGroup>
                </Stack>
              </Stack>
              <Table
                rowHeight={60}
                data={categorydata.filter(item => {
                  const CategoryName = item.attributes.CategoryName ? item.attributes.CategoryName.toLowerCase() : '';
                  return (
                    CategoryName.includes(searchQuery1.toLowerCase())
                  )
                })}
                height={400}
                rowKey="id"
                bordered
              >
                <Table.Column width={60} fixed>
                  <Table.HeaderCell><b>Sr No.</b></Table.HeaderCell>
                  <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                </Table.Column>
                <Table.Column align='center' width={150} flexGrow={1}>
                  <Table.HeaderCell><b>Category Name</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIds.includes(rowData.id) ? (
                        <Input
                          value={editedData[rowData.id]?.CategoryName || rowData.attributes.CategoryName}
                          onChange={(value) => handleInputChangeCategory(rowData.id, 'CategoryName', value)}
                        />
                      ) : (
                        rowData.attributes.CategoryName
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
                <Table.Column width={150} fixed="right">
                  <Table.HeaderCell><b>Action</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIds.includes(rowData.id) ? (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<CheckIcon />}
                            active
                            onClick={() => handleSaveRowCategory(rowData.id)}
                            style={{ marginRight: '10px' }}
                          />
                          <IconButton
                            size="sm"
                            icon={<CloseIcon />}
                            active
                            onClick={() => setEditedRowIds((prevRowIds) => prevRowIds.filter((id) => id !== rowData.id))}
                          />
                        </div>
                      ) : (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<EditIcon />}
                            active
                            onClick={() => handleEditRowCategory(rowData)}
                          />
                          {/* <IconButton
                                size="sm"
                                icon={<TrashIcon />}
                                active
                                onClick={() => handleDeleteRow(rowData.id)}
                            /> */}
                        </div>
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
              </Table>
              <Stack justifyContent='flex-end'>
              {paginationcategory.pageCount > 1 && (
                <Pagination
                  prev
                  last
                  next
                  first
                  size="xs"
                  total={paginationcategory.total}
                  limit={paginationcategory.pageSize}
                  activePage={paginationcategory.page}
                  onChangePage={setActivePagecategorie}
                />
              )}
              </Stack>
            </>
          )}

          {activeKey === 'content2' && (
            <>
              <Form.ControlLabel><b>Product Type</b></Form.ControlLabel>
              <Stack justifyContent='space-between' style={{ marginBottom: '10px' }}>
                <Stack spacing={160}>
                  <Input id="ProductTypeName"
                    name="ProductTypeName"
                    style={{ width: '180%' }}
                    value={productType && productType.ProductTypeName ? productType.ProductTypeName : ''} onChange={value => handleInputChange2('ProductTypeName', value, 0)}
                    onPressEnter={submit2}
                  />
                  <Button appearance='primary' color='cyan' onClick={submit2}> Add</Button>
                </Stack>
                <Stack>
                  <InputGroup inside >
                    <Input placeholder="Search" type="text" value={searchQuery2} onChange={handleSearch2} />
                    <InputGroup.Addon>
                      <SearchIcon />
                    </InputGroup.Addon>
                  </InputGroup>
                </Stack>
              </Stack>
              <Table
                rowHeight={60}
                data={productTypedata.filter(item => {
                  const ProductTypeName = item.attributes.ProductTypeName ? item.attributes.ProductTypeName.toLowerCase() : '';
                  return (
                    ProductTypeName.includes(searchQuery2.toLowerCase())
                  )
                })}
                height={400}
                rowKey="id"
                bordered
              >
                <Table.Column width={60} fixed>
                  <Table.HeaderCell><b>Sr. No.</b></Table.HeaderCell>
                  <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                </Table.Column>
                <Table.Column align='center' width={150} flexGrow={1}>
                  <Table.HeaderCell><b>Product Type</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsProduct.includes(rowData.id) ? (
                        <Input
                          value={editedDataProduct[rowData.id]?.ProductTypeName || rowData.attributes.ProductTypeName}
                          onChange={(value) => handleInputChangeProduct(rowData.id, 'ProductTypeName', value)}
                        />
                      ) : (
                        rowData.attributes.ProductTypeName
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
                <Table.Column width={150} fixed="right">
                  <Table.HeaderCell><b>Action</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsProduct.includes(rowData.id) ? (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<CheckIcon />}
                            active
                            onClick={() => handleSaveRowProduct(rowData.id)}
                            style={{ marginRight: '10px' }}
                          />
                          <IconButton
                            size="sm"
                            icon={<CloseIcon />}
                            active
                            onClick={() => setEditedRowIdsProduct((prevRowIds) => prevRowIds.filter((id) => id !== rowData.id))}
                          />
                        </div>
                      ) : (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<EditIcon />}
                            active
                            onClick={() => handleEditRowProduct(rowData)}
                          />
                          {/* <IconButton
                                size="sm"
                                icon={<TrashIcon />}
                                active
                                onClick={() => handleDeleteRow(rowData.id)}
                            /> */}
                        </div>
                      )
                    )}
                  </Table.Cell>

                </Table.Column>
              </Table>
              <Stack justifyContent='flex-end'>
              {paginationproductType.pageCount > 1 && (
                <Pagination
                  prev
                  last
                  next
                  first
                  size="xs"
                  total={paginationproductType.total}
                  limit={paginationproductType.pageSize}
                  activePage={paginationproductType.page}
                  onChangePage={setActivePageproducttype}
                />
              )}
              </Stack>
            </>
          )}
          {activeKey === 'content3' && (
            <>
              <Form.ControlLabel><b>Collection Name</b></Form.ControlLabel>
              <Stack justifyContent='space-between' style={{ marginBottom: '10px' }}>
                <Stack spacing={160}>
                  <Input id="MatCollectionName"
                    name="MatCollectionName"
                    style={{ width: '180%' }}
                    value={collection && collection.MatCollectionName ? collection.MatCollectionName : ''} onChange={value => handleInputChange3('MatCollectionName', value, 0)}
                    onPressEnter={submit3}
                  />

                  <Button appearance='primary' color='cyan' onClick={submit3}> Add</Button>
                </Stack>
                <Stack>
                  <InputGroup inside >
                    <Input placeholder="Search" type="text" value={searchQuery3} onChange={handleSearch3} />
                    <InputGroup.Addon>
                      <SearchIcon />
                    </InputGroup.Addon>
                  </InputGroup>
                </Stack>
              </Stack>
              <Table
                rowHeight={60}
                data={collectiondata.filter(item => {
                  const MatCollectionName = item.attributes.MatCollectionName ? item.attributes.MatCollectionName.toLowerCase() : '';
                  return (
                    MatCollectionName.includes(searchQuery3.toLowerCase())
                  )
                })}
                height={400}
                rowKey="id"
                bordered
              >
                <Table.Column width={60} fixed>
                  <Table.HeaderCell><b>Sr No.</b></Table.HeaderCell>
                  <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                </Table.Column>

                <Table.Column align='center' width={150} flexGrow={1}>
                  <Table.HeaderCell><b>Collection Name</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsCollection.includes(rowData.id) ? (
                        <Input
                          value={editedDataCollection[rowData.id]?.MatCollectionName || rowData.attributes.MatCollectionName}
                          onChange={(value) => handleInputChangeCollection(rowData.id, 'MatCollectionName', value)}
                        />
                      ) : (
                        rowData.attributes.MatCollectionName
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
                <Table.Column width={150} fixed="right">
                  <Table.HeaderCell><b>Action</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsCollection.includes(rowData.id) ? (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<CheckIcon />}
                            active
                            onClick={() => handleSaveRowCollection(rowData.id)}
                            style={{ marginRight: '10px' }}
                          />
                          <IconButton
                            size="sm"
                            icon={<CloseIcon />}
                            active
                            onClick={() => setEditedRowIdsCollection((prevRowIds) => prevRowIds.filter((id) => id !== rowData.id))}
                          />
                        </div>
                      ) : (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<EditIcon />}
                            active
                            onClick={() => handleEditRowCollection(rowData)}
                          />
                          {/* <IconButton
                                size="sm"
                                icon={<TrashIcon />}
                                active
                                onClick={() => handleDeleteRow(rowData.id)}
                            /> */}
                        </div>
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
              </Table>
              <Stack justifyContent='flex-end'>
              {paginationcollection.pageCount > 1 && (
                <Pagination
                  prev
                  last
                  next
                  first
                  size="xs"
                  total={paginationcollection.total}
                  limit={paginationcollection.pageSize}
                  activePage={paginationcollection.page}
                  onChangePage={setActivePagematerialcollections}
                />
              )}
              </Stack>
            </>
          )}
          {activeKey === 'content4' && (
            <>
              <Form.ControlLabel><b>Finish Name</b></Form.ControlLabel>
              <Stack justifyContent='space-between' style={{ marginBottom: '10px' }}>
                <Stack spacing={160}>
                  <Input id="FinishName"
                    name="FinishName"
                    style={{ width: '180%' }}
                    value={finish && finish.FinishName ? finish.FinishName : ''} onChange={value => handleInputChange4('FinishName', value, 0)}
                    onPressEnter={submit4}
                  />
                  <Button appearance='primary' color='cyan' onClick={submit4}> Add</Button>
                </Stack>
                <Stack>
                  <InputGroup inside >
                    <Input placeholder="Search" type="text" value={searchQuery4} onChange={handleSearch4} />
                    <InputGroup.Addon>
                      <SearchIcon />
                    </InputGroup.Addon>
                  </InputGroup>
                </Stack>
              </Stack>
              <Table
                rowHeight={60}
                data={finishdata.filter(item => {
                  const FinishName = item.attributes.FinishName ? item.attributes.FinishName.toLowerCase() : '';
                  return (
                    FinishName.includes(searchQuery4.toLowerCase())
                  )
                })}
                height={400}
                rowKey="id"
                bordered
              >
                <Table.Column width={60} fixed>
                  <Table.HeaderCell><b>Sr. No.</b></Table.HeaderCell>
                  <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                </Table.Column>

                <Table.Column align='center' width={150} flexGrow={1}>
                  <Table.HeaderCell><b>Finish Name</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsFinish.includes(rowData.id) ? (
                        <Input
                          value={editedDataFinish[rowData.id]?.FinishName || rowData.attributes.FinishName}
                          onChange={(value) => handleInputChangeFinish(rowData.id, 'FinishName', value)}
                        />
                      ) : (
                        rowData.attributes.FinishName
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
                <Table.Column width={150} fixed="right">
                  <Table.HeaderCell><b>Action</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsFinish.includes(rowData.id) ? (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<CheckIcon />}
                            active
                            onClick={() => handleSaveRowFinish(rowData.id)}
                            style={{ marginRight: '10px' }}
                          />
                          <IconButton
                            size="sm"
                            icon={<CloseIcon />}
                            active
                            onClick={() => setEditedRowIdsFinish((prevRowIds) => prevRowIds.filter((id) => id !== rowData.id))}
                          />
                        </div>
                      ) : (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<EditIcon />}
                            active
                            onClick={() => handleEditRowFinish(rowData)}
                          />
                          {/* <IconButton
                                size="sm"
                                icon={<TrashIcon />}
                                active
                                onClick={() => handleDeleteRow(rowData.id)}
                            /> */}
                        </div>
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
              </Table>
              <Stack justifyContent='flex-end'>
              {paginationfinish.pageCount > 1 && (
                <Pagination
                  prev
                  last
                  next
                  first
                  size="xs"
                  total={paginationfinish.total}
                  limit={paginationfinish.pageSize}
                  activePage={paginationfinish.page}
                  onChangePage={setActivePagefinishes}
                />
              )}
              </Stack>
            </>
          )}
          {activeKey === 'content5' && (
            <>
              <Form.ControlLabel><b>Color Name</b></Form.ControlLabel>
              <Stack justifyContent='space-between' style={{ marginBottom: '10px' }}>
                <Stack spacing={160}>
                  <Input id="ColorName"
                    name="ColorName"
                    style={{ width: '180%' }}
                    value={color && color.ColorName ? color.ColorName : ''} onChange={value => handleInputChange5('ColorName', value, 0)}
                    onPressEnter={submit5}
                  />
                  <Button appearance='primary' color='cyan' onClick={submit5}> Add</Button>
                </Stack>
                <Stack>
                  <InputGroup inside >
                    <Input placeholder="Search" type="text" value={searchQuery5} onChange={handleSearch5} />
                    <InputGroup.Addon>
                      <SearchIcon />
                    </InputGroup.Addon>
                  </InputGroup>
                </Stack>
              </Stack>
              <Table
                rowHeight={60}
                data={colordata.filter(item => {
                  const ColorName = item.attributes.ColorName ? item.attributes.ColorName.toLowerCase() : '';
                  return (
                    ColorName.includes(searchQuery5.toLowerCase())
                  )
                })}
                height={400}
                rowKey="id"
                bordered
              >
                <Table.Column width={60} fixed>
                  <Table.HeaderCell><b>Sr No.</b></Table.HeaderCell>
                  <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                </Table.Column>

                <Table.Column align='center' width={150} flexGrow={1}>
                  <Table.HeaderCell><b>Color Name</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsColor.includes(rowData.id) ? (
                        <Input
                          value={editedDataColor[rowData.id]?.ColorName || rowData.attributes.ColorName}
                          onChange={(value) => handleInputChangeColor(rowData.id, 'ColorName', value)}
                        />
                      ) : (
                        rowData.attributes.ColorName
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
                <Table.Column width={150} fixed="right">
                  <Table.HeaderCell><b>Action</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsColor.includes(rowData.id) ? (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<CheckIcon />}
                            active
                            onClick={() => handleSaveRowColor(rowData.id)}
                            style={{ marginRight: '10px' }}
                          />
                          <IconButton
                            size="sm"
                            icon={<CloseIcon />}
                            active
                            onClick={() => setEditedRowIdsColor((prevRowIds) => prevRowIds.filter((id) => id !== rowData.id))}
                          />
                        </div>
                      ) : (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<EditIcon />}
                            active
                            onClick={() => handleEditRowColor(rowData)}
                          />
                          {/* <IconButton
                                size="sm"
                                icon={<TrashIcon />}
                                active
                                onClick={() => handleDeleteRow(rowData.id)}
                            /> */}
                        </div>
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
              </Table><Stack justifyContent='flex-end'>
              {paginationcolor.pageCount > 1 && (
                <Pagination
                  prev
                  last
                  next
                  first
                  size="xs"
                  total={paginationcolor.total}
                  limit={paginationcolor.pageSize}
                  activePage={paginationcolor.page}
                  onChangePage={setActivePagecolor}
                />
              )}
              </Stack>
            </>
          )}
          {activeKey === 'content6' && (
            <>
              <Form.ControlLabel><b>HSN Code</b></Form.ControlLabel>
              <Stack justifyContent='space-between' style={{ marginBottom: '10px' }}>
                <Stack spacing={160}>
                  <Input id="hscode"
                    name="hscode"
                    style={{ width: '180%' }}
                    value={hscode && hscode.hscode ? hscode.hscode : ''} onChange={value => handleInputChange6('hscode', value, 0)}
                    onPressEnter={submit6}
                  />
                  <Button appearance='primary' color='cyan' onClick={submit6}> Add</Button>
                </Stack>
                <Stack>
                  <InputGroup inside >
                    <Input placeholder="Search" type="text" value={searchQuery6} onChange={handleSearch6} />
                    <InputGroup.Addon>
                      <SearchIcon />
                    </InputGroup.Addon>
                  </InputGroup>
                </Stack>
              </Stack>
              <Table
                rowHeight={60}
                data={hsdata.filter(item => {
                  const hscode = item.attributes.hscode ? item.attributes.hscode.toLowerCase() : '';
                  return (
                    hscode.includes(searchQuery6.toLowerCase())
                  )
                })}
                height={400}
                rowKey="id"
                bordered
              >
                <Table.Column width={60} fixed>
                  <Table.HeaderCell><b>Sr No.</b></Table.HeaderCell>
                  <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                </Table.Column>
                <Table.Column align='center' width={150} flexGrow={1}>
                  <Table.HeaderCell><b>HSN Code</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsHSN.includes(rowData.id) ? (
                        <Input
                          value={editedDataHSN[rowData.id]?.hscode || rowData.attributes.hscode}
                          onChange={(value) => handleInputChangeHSN(rowData.id, 'hscode', value)}
                        />
                      ) : (
                        rowData.attributes.hscode
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
                <Table.Column width={150} fixed="right">
                  <Table.HeaderCell><b>Action</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsHSN.includes(rowData.id) ? (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<CheckIcon />}
                            active
                            onClick={() => handleSaveRowHSN(rowData.id)}
                            style={{ marginRight: '10px' }}
                          />
                          <IconButton
                            size="sm"
                            icon={<CloseIcon />}
                            active
                            onClick={() => setEditedRowIdsHSN((prevRowIds) => prevRowIds.filter((id) => id !== rowData.id))}
                          />
                        </div>
                      ) : (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<EditIcon />}
                            active
                            onClick={() => handleEditRowHSN(rowData)}
                          />
                          {/* <IconButton
                                size="sm"
                                icon={<TrashIcon />}
                                active
                                onClick={() => handleDeleteRow(rowData.id)}
                            /> */}
                        </div>
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
              </Table>
              <Stack justifyContent='flex-end'>
              {paginationhs.pageCount > 1 && (
                <Pagination
                  prev
                  last
                  next
                  first
                  size="xs"
                  total={paginationhs.total}
                  limit={paginationhs.pageSize}
                  activePage={paginationhs.page}
                  onChangePage={setActivePagehscode}
                />
              )}
              </Stack>
            </>
          )}
          {activeKey === 'content7' && (
            < >
              <Form.ControlLabel><b>Material Name</b></Form.ControlLabel>
              <Stack justifyContent='space-between' style={{ marginBottom: '10px' }}>
                <Stack spacing={160}>
                  <Input id="MaterialName"
                    name="MaterialName"
                    style={{ width: '180%' }}
                    value={material && material.MaterialName ? material.MaterialName : ''} onChange={value => handleInputChange7('MaterialName', value, 0)}
                    onPressEnter={submit7}
                  />
                  <Button appearance='primary' color='cyan' onClick={submit7}>Add</Button>
                </Stack>
                <Stack>
                  <InputGroup inside >
                    <Input placeholder="Search" type="text" value={searchQuery7} onChange={handleSearch7} />
                    <InputGroup.Addon>
                      <SearchIcon />
                    </InputGroup.Addon>
                  </InputGroup>
                </Stack>
              </Stack>
              <Table
                rowHeight={60}
                data={materialdata.filter(item => {
                  const MaterialName = item.attributes.MaterialName ? item.attributes.MaterialName.toLowerCase() : '';
                  return (
                    MaterialName.includes(searchQuery7.toLowerCase())
                  )
                })}
                height={400}
                rowKey="id"
                bordered
              >
                <Table.Column width={60} fixed>
                  <Table.HeaderCell><b>Sr. No.</b></Table.HeaderCell>
                  <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                </Table.Column>

                <Table.Column align='center' width={150} flexGrow={1}>
                  <Table.HeaderCell><b>Material Name</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsMAT.includes(rowData.id) ? (
                        <Input
                          value={editedDataMAT[rowData.id]?.MaterialName || rowData.attributes.MaterialName}
                          onChange={(value) => handleInputChangeMAT(rowData.id, 'MaterialName', value)}
                        />
                      ) : (
                        rowData.attributes.MaterialName
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
                <Table.Column width={150} fixed="right">
                  <Table.HeaderCell><b>Action</b></Table.HeaderCell>
                  <Table.Cell>
                    {(rowData) => (
                      editedRowIdsMAT.includes(rowData.id) ? (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<CheckIcon />}
                            active
                            onClick={() => handleSaveRowMAT(rowData.id)}
                            style={{ marginRight: '10px' }}
                          />
                          <IconButton
                            size="sm"
                            icon={<CloseIcon />}
                            active
                            onClick={() => setEditedRowIdsMAT((prevRowIds) => prevRowIds.filter((id) => id !== rowData.id))}
                          />
                        </div>
                      ) : (
                        <div>
                          <IconButton
                            size="sm"
                            icon={<EditIcon />}
                            active
                            onClick={() => handleEditRowMAT(rowData)}
                          />
                          {/* <IconButton
                                size="sm"
                                icon={<TrashIcon />}
                                active
                                onClick={() => handleDeleteRow(rowData.id)}
                            /> */}
                        </div>
                      )
                    )}
                  </Table.Cell>
                </Table.Column>
              </Table>
              <Stack justifyContent='flex-end'>
              {paginationmaterial.pageCount > 1 && (
                <Pagination
                  prev
                  last
                  next
                  first
                  size="xs"
                  total={paginationmaterial.total}
                  limit={paginationmaterial.pageSize}
                  activePage={paginationmaterial.page}
                  onChangePage={setActivePagematerial}
                />
              )}
              </Stack>
            </>
          )}
        </Panel>
        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
      </Container>
    </>
  );
};
export default Master;